import { ReadonlyVec3, vec3 } from 'gl-matrix';
import { Observable } from '../core/observable';

/**
 * {@link PointOfInterest} represents a single 3D point in PatientSpace.
 */
export class PointOfInterest extends Observable<ReadonlyVec3> {
    /**
     *
     */
    private readonly _pointOfInterestCoordinates: vec3;

    public constructor(initialCoordinates: vec3 = [0, 0, 0]) {
        super();
        this._pointOfInterestCoordinates = initialCoordinates
            ? vec3.clone(initialCoordinates)
            : vec3.create();
    }

    public get coordinates(): ReadonlyVec3 {
        return this._pointOfInterestCoordinates;
    }

    public set coordinates(coordinates: ReadonlyVec3) {
        vec3.copy(this._pointOfInterestCoordinates, coordinates);
        this.notify(coordinates);
    }

    public add(delta: ReadonlyVec3): ReadonlyVec3 {
        const coords = vec3.add(
            this._pointOfInterestCoordinates,
            this._pointOfInterestCoordinates,
            delta
        );
        this.notify(this._pointOfInterestCoordinates);
        return coords;
    }
}
